<template>
  <div name="demo-export-html">
  	export html
  </div>
</template>

<script>
export default {
  name: 'demo-export-html'
}
</script>


// WEBPACK FOOTER //
// demoExportHtml.vue?0396377f